var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"btn-link",attrs:{"to":`/properties/${this.item.property_id}/areas/${this.item.id}`}},[_vm._v(" "+_vm._s(this.item.name)+" ("+_vm._s(this.item.items.length)+" items) ")])
}
var staticRenderFns = []

export { render, staticRenderFns }